/**
 * Shared state for parent window origin
 * This module breaks circular dependencies between editor-mode.js and editor-overlay.js
 */

let parentOrigin = null;

/**
 * Get the stored parent origin for sending messages
 * @returns {string|null} The parent origin or null if not yet established
 */
export function getParentOrigin() {
  return parentOrigin;
}

/**
 * Set the parent origin (called when first valid message is received)
 * @param {string} origin - The verified parent origin
 */
export function setParentOrigin(origin) {
  parentOrigin = origin;
}
